<template>
  <div>
    <template v-if="!loading">
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content step="1">
            <select-template v-if="e1 === 1" @goToPage="goToPage">
            </select-template>
          </v-stepper-content>

          <v-stepper-content step="3">
            <create-richmenu
              v-if="e1 === 3"
              @goToPage="goToPage"
            ></create-richmenu>
          </v-stepper-content>

          <v-stepper-content step="5">
            <select-action v-if="e1 === 5" @goToPage="goToPage"></select-action>
          </v-stepper-content>
          <v-stepper-content step="8">
            <line-connenct v-if="e1 === 8" @goToPage="goToPage"></line-connenct>
          </v-stepper-content>
          <v-stepper-content step="2">
            <choose-upload-image
              v-if="e1 === 2"
              @goToPage="goToPage"
            ></choose-upload-image>
          </v-stepper-content>
          <v-stepper-content step="4">
            <chosen-image v-if="e1 === 4" @goToPage="goToPage"></chosen-image>
          </v-stepper-content>
          <v-stepper-content step="6">
            <edit-bar-label-page
              v-if="e1 === 6"
              @goToPage="goToPage"
            ></edit-bar-label-page>
          </v-stepper-content>
          <v-stepper-content step="7">
            <payment-plan v-if="e1 === 7" @goToPage="goToPage"></payment-plan>
          </v-stepper-content>
          <v-stepper-content step="9">
            <confirm-connect
              v-if="e1 === 9"
              @goToPage="goToPage"
            ></confirm-connect>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>

    <div style="height: 60px"></div>
  </div>
</template>

<script>
import SelectTemplate from '../components/lineRichmenuManager/selectTemplate'
import SelectAction from '../components/lineRichmenuManager/selectAction'
import CreateRichmenu from '../components/lineRichmenuManager/CreateRichmenu'
import LineConnenct from '../components/lineRichmenuManager/LineConnenct'
import ChooseUploadImage from '../components/lineRichmenuManager/ChooseUploadImage'
import ChosenImage from '../components/lineRichmenuManager/chosenImage'
import EditBarLabelPage from '../components/lineRichmenuManager/EditBarLabelPage'
import PaymentPlan from '../components/lineRichmenuManager/PaymentPlan'
import ConfirmConnect from '../components/lineRichmenuManager/ConfirmConnect'
import { mapGetters } from 'vuex'
export default {
  components: {
    SelectTemplate,
    SelectAction,
    CreateRichmenu,
    LineConnenct,
    ChooseUploadImage,
    ChosenImage,
    EditBarLabelPage,
    PaymentPlan,
    ConfirmConnect
  },
  data() {
    return {
      e1: 1,
      ImageSelect: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      getTypeEditNew: 'lineRichmenuManager/getTypeEditNew'
    })
  },
  async mounted() {
    this.loading = true
    if (this.$route.query?.rmid) {
      var richmenu_response = await this.$store.dispatch(
        'lineRichmenuManager/getLineRichMenu'
      )

      if (richmenu_response) {
        let richMenu = richmenu_response.data.data.find((richMenu) => {
          return richMenu.id == this.$route.query?.rmid
        })

        if (richMenu) {
          try {
            this.$set(
              richMenu,
              'content_json',
              JSON.parse(richMenu.content_json)
            )
          } catch (error) {
            console.error(error)
          }

          this.$store.dispatch(
            'lineRichmenuManager/setTemplateSelect',
            richMenu
          )
          this.$store.dispatch('lineRichmenuManager/setTypeEditNew', 'edit')
          this.$store.dispatch('lineRichmenuManager/setIdTemplate', richMenu.id)

          // this.image = await this.loadImage(this.richMenu.image_url);
        }
      }
    }

    if (this.$route.query?.step) {
      try {
        this.goToPage(parseInt(this.$route.query?.step))
      } catch (err) {
        const path = `/${this.currentLang}/richmenu`
        if (this.$route.path !== path) {
          this.$router.push({ path })
        }
      }
    } else if (this.getTypeEditNew === 'edit') {
      this.goToPage(5)
    }

    this.loading = false
  },
  methods: {
    goToPage(page) {
      this.e1 = page
      let query = {
        ...this.$route.query
      }
      query.step = this.e1
      try {
        this.$router.replace({ query: query }).catch(() => {
          // console.error(err)
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pr-pl-12 {
  padding: 0px 12px;
}
.v-stepper__content {
  padding: 0px;
}
.v-stepper {
  box-shadow: none;
}
.v-stepper__header {
  box-shadow: none;
}
</style>
